<template>
  <ModalDefault modal_id="editLead"
                size="modal-lg modal-dialog-scrollable"
                header="y"
                :modal_header="getTranslations('expression_723')"
                icon="bx bx-edit-alt"
                class_body="p-0"
                :method="updateLead"
                footer="y">
    <div slot="body">
      <div class="card-header bg-white">
        <div class="row">
          <div class="col-12 d-flex px-4">
            <div :class="edit_view === 1 ? 'title-color font-weight-bold' : ''" @click.prevent="edit_view = 1" class="pr-2 cursor_pointer">
              <i class="bx bx-info-circle mr-2"></i> <small>{{ getTranslations('expression_166') }}</small>
            </div>
            <div :class="edit_view === 2 ? 'title-color font-weight-bold' : ''" @click.prevent="edit_view = 2" class="pl-4 cursor_pointer">
              <i class="bx bx-map mr-2"></i> <small>{{ getTranslations('expression_175') }}</small>
            </div>
          </div>
        </div>
      </div>
      <div style="min-height: 340px; overflow-y: auto" class="card-body">
        <div v-if="edit_view === 1" class="animated--grow-in">
          <div class="row pt-2 pb-3">
            <div class="col-md-6 px-4">
              <label class="mb-0">{{ getTranslations('expression_42') }} </label>
              <div class="input-group mb-3">
                <input type="text"
                       v-model="lead.name"
                       class="input_forms form-control">
              </div>
            </div>
            <div class="col-md-6 px-4">
              <label class="mb-0">{{ getTranslations('expression_161') }} </label>
              <div class="input-group mb-3">
                <input type="email"
                       v-model="lead.email"
                       class="input_forms form-control">
              </div>
            </div>
            <div class="col-md-6 px-4">
              <label class="mb-0">{{ getTranslations('expression_168') }} </label>
              <div class="input-group mb-3">
                <input type="text"
                       v-model="lead.document"
                       class="input_forms form-control">
              </div>
            </div>
            <div class="col-md-6 px-4">
              <label class="mb-0">{{ getTranslations('expression_566') }} </label>
              <div class="input-group mb-3">
                <select v-model="lead.genre_key" class="input_forms custom-select">
                  <option :value="2">{{ getTranslations('expression_567') }}</option>
                  <option :value="0">{{ getTranslations('expression_568') }}</option>
                  <option :value="1">{{ getTranslations('expression_569') }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-4 px-4">
              <label class="mb-0">{{ getTranslations('expression_173') }} </label>
              <div class="input-group mb-3">
                <input type="text"
                       v-model="lead.company"
                       class="input_forms form-control">
              </div>
            </div>
            <div class="col-md-4 px-4">
              <label class="mb-0">{{ getTranslations('expression_174') }} </label>
              <div class="input-group mb-3">
                <input type="text"
                       v-model="lead.office"
                       class="input_forms form-control">
              </div>
            </div>
            <div class="col-md-4 px-4">
              <label class="mb-0">{{ getTranslations('expression_160') }} </label>
              <div class="input-group mb-3">
                <select v-model="lead.newsletter_key"
                        class="input_forms custom-select">
                  <option v-for="newsletter in configs.data.lead_campaigns"
                          :key="newsletter.id"
                          :value="newsletter.id">
                    {{ newsletter.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="edit_view === 2" class="animated--grow-in">
          <div class="row pt-2 pb-3">
            <div class="col-md-6 px-4">
              <label class="mb-0">{{ getTranslations('expression_176') }} </label>
              <div class="input-group mb-3">
                <input type="text"
                       v-model="lead.address.zip_code"
                       class="input_forms form-control">
              </div>
            </div>
            <div class="col-md-6 px-4">
              <label class="mb-0">{{ getTranslations('expression_175') }} </label>
              <div class="input-group mb-3">
                <input type="text"
                       v-model="lead.address.street"
                       class="input_forms form-control">
              </div>
            </div>
            <div class="col-md-6 px-4">
              <label class="mb-0">{{ getTranslations('expression_178') }} </label>
              <div class="input-group mb-3">
                <input type="text"
                       v-model="lead.address.number"
                       class="input_forms form-control">
              </div>
            </div>
            <div class="col-md-6 px-4">
              <label class="mb-0">{{ getTranslations('expression_179') }} </label>
              <div class="input-group mb-3">
                <input type="text"
                       v-model="lead.address.district"
                       class="input_forms form-control">
              </div>
            </div>
            <div class="col-md-6 px-4">
              <label class="mb-0">{{ getTranslations('expression_177') }} </label>
              <div class="input-group mb-3">
                <input type="text"
                       v-model="lead.address.city"
                       class="input_forms form-control">
              </div>
            </div>
            <div class="col-md-6 px-4">
              <label class="mb-0">{{ getTranslations('expression_180') }} </label>
              <div class="input-group mb-3">
                <input type="text"
                       v-model="lead.address.state"
                       class="input_forms form-control">
              </div>
            </div>
            <div class="col-md-6 px-4">
              <label class="mb-0">{{ getTranslations('expression_182') }} </label>
              <div class="input-group mb-3">
                <input type="text"
                       v-model="lead.address.country"
                       class="input_forms form-control">
              </div>
            </div>
            <div class="col-md-6 px-4">
              <label class="mb-0">{{ getTranslations('expression_365') }} </label>
              <div class="input-group mb-3">
                <input type="text"
                       v-model="lead.address.reference"
                       class="input_forms form-control">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="d-flex justify-content-end px-2">
          <span @click.prevent="updateLead"
                data-dismiss="modal"
                class="shadow-sm cursor_pointer btn-secondary text-white py-2 px-3">
            <i class="bx bx-save"></i>
            <span class="ml-2">{{ getTranslations('expression_240') }}</span>
          </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";

export default {
  name: "ModalEditLead",
  data(){
    return {
      edit_view: 1,
      lead: {
        address: {}
      }
    }
  },
  components: {
    ModalDefault,
  },
  computed: {
    ...mapState(['leads', 'notes', 'lead_tags', 'histories', 'tickets', 'wallets', 'users', 'channels', 'operators', 'configs']),
    ...mapGetters([
      'getTagObject',
      'getTagsArray',
      'getLeadTagObject',
      'getLeadObject',
      'getMotiveObject',
      'getOperatorObject',
      'getNoteTypeObject',
      'getUserObject',
      'getInterestsArray',
      'getInterestObject',
      'getChannelObject',
      'getDepartmentObject',
      'getDepartmentsArray',
      'getOperatorsArray',
    ]),
  },
  created() {
    $('#editLead').on('hidden.bs.modal', () => {
      this.lead = {
        address: {}
      }
    })
  },
  mounted() {
    this.$root.$on('editLead', (payload) => {
      this.lead = this.xeroxHelper(payload)
    })
  },
  methods: {
    updateLead(){
      this.$store.dispatch('updateLead', this.lead)
      $('#editLead').modal('hide')
    },
  }
}
</script>

<style scoped>

</style>
